<form (submit)="onSave()">
  <insurance-editor [insurances]="insurances"></insurance-editor>
  <button type="submit" class="save-btn">Сохранить</button>
</form>
